import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeClearAssetAttributes extends Node
{
	constructor(pParent)
	{
		super(pParent);
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{
		return 'clearAssetAttributes';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		let resList = [];
		for(let mesh of pGeoList)
		{
			if(!mesh)
				continue;

			let pNewMesh = Utils3D.clearAssetAttributes(mesh, this.getId());
			resList.push(pNewMesh);
		}

		return resList;
	}
}